__turbopack_context__.v({
  "iconCell": "cells-module-scss-module__8wI5wW__iconCell",
  "leadsContent": "cells-module-scss-module__8wI5wW__leadsContent",
  "sectorLabel": "cells-module-scss-module__8wI5wW__sectorLabel",
  "tickerBadge": "cells-module-scss-module__8wI5wW__tickerBadge",
});
